/** Short label of a template schedule, e.g. "Elke maandag 09:00". */
import type { TFunction } from 'i18next';
import type { TemplateSchedule } from '@nexus/core';

/** Weekday name; 4 October 2026 is a Sunday (0). */
export const weekdayName = (day: number, locale: string) =>
  new Intl.DateTimeFormat(locale, { weekday: 'long' }).format(new Date(2026, 9, 4 + day));

export function scheduleLabel(t: TFunction, s: TemplateSchedule, locale: string): string {
  if (s.every === 'day') return t('templates.repeat.labelDay', { time: s.time });
  if (s.every === 'weekdays') return t('templates.repeat.labelWeekdays', { time: s.time });
  if (s.every === 'week')
    return t('templates.repeat.labelWeek', { day: weekdayName(s.weekday, locale), time: s.time });
  return t('templates.repeat.labelMonth', { day: s.monthDay, time: s.time });
}
